module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-4500-Classes-Active-1a7faca6e1ccedc526af6d1b8bd2e3d0.png";